import LocalDataManager from './LocalDataManager';
import TargetManager from './TargetManager';

import BroadcastService from '../services/BroadcastService';

export default class BlastDataManager {

    constructor(indexDbManager) {
        if (indexDbManager)
            this.indexedDbManager = indexDbManager;
        else
            this.indexedDbManager = new LocalDataManager();

        this.targetManager = new TargetManager();

        this.compareSets = ["cYNOW", "cYWTD", "cYMTD", "cYQTD", "cYYTD",
            "lYNOW", "lYWTD", "lYMTD", "lYQTD", "lYYTD",
            "lPEOD", "lPEOW", "lPEOM", "lPEOQ", "lPEOY",
            "lPNOW", "lPWTD", "lPMTD", "lPQTD", "lPYTD",
            "lPODD", "lPODW", "lPODM", "lPODQ", "lPODY"];

        this.errmsg = "Something went wrong while loading data.";
        this.getFilter = this.getFilter.bind(this);
        this.setFilter = this.setFilter.bind(this);
        this.clearFliter = this.clearFliter.bind(this);
        this.getAllLists = this.getAllLists.bind(this);
        this.getLocationMetricList = this.getLocationMetricList.bind(this);
        this.getEmployeeMetricList = this.getEmployeeMetricList.bind(this);
        this.getDistrictMetricList = this.getDistrictMetricList.bind(this);
        this.getDistrictLocationList = this.getDistrictLocationList.bind(this);
        this.getDistrictList = this.getDistrictList.bind(this);
        this.getLocationData = this.getLocationData.bind(this);
        this.getLocationsData = this.getLocationsData.bind(this);
        this.getEmployeeData = this.getEmployeeData.bind(this);
        this.getEmployeesData = this.getEmployeesData.bind(this);
        this.getAllEmployeeData = this.getAllEmployeeData.bind(this);
        this.getDistrictsData = this.getDistrictsData.bind(this);
        this.getDistrictData = this.getDistrictData.bind(this);
        this.getDistrictLocationsData = this.getDistrictLocationsData.bind(this);
        this.getDistrictLocationData = this.getDistrictLocationData.bind(this);
        this.getEmployeeUserMap = this.getEmployeeUserMap.bind(this);
        this.getEmployeePhoneNumbers = this.getEmployeePhoneNumbers.bind(this);
        this.getLocationPhoneNumbers = this.getLocationPhoneNumbers.bind(this);

        this.overwriteEmployeeValues = this.overwriteEmployeeValues.bind(this);

        this.loadBlastData = this.loadBlastData.bind(this);

    }

    getFilter(callback) {
        return this.indexedDbManager.getBlastFilter(callback);
    }

    setFilter(blastFilter) {
        return this.indexedDbManager.saveBlastFilter(blastFilter)
    }

    clearFliter() {
        this.indexedDbManager.clearBlastFilter()
    }

    ///////////////////////////////////////////////////////////////////////////////////// Get Lists

    async getAllLists(filter) {
        let self = this;

        let allListObj = {
            districtMetricList: [],
            districtList: [],
            districtLocationMetricList: [],
            districtLocationList: [],
            locationMetricList: [],
            locationList: [],
            employeeMetricList: [],
            employeeList: [],
            allEmployeeList: []
        }

        let blastLocationData = await this.indexedDbManager.getBlastLocationDataQuery();
        let blastDistrictLocationData = filter === undefined ? [] : await this.indexedDbManager.getBlastLocationDataQuery(undefined, filter.districtId);
        let blastEmployeesData = await this.indexedDbManager.getBlastEmployeeDataQuery();
        let blastStoreEmployeesData = filter === undefined ? [] : await this.indexedDbManager.getBlastEmployeeDataQuery(filter.storeId);

        let locMetRes = this.sortMetricList(blastLocationData);
        allListObj.districtMetricList = locMetRes;
        allListObj.districtLocationMetricList = this.sortMetricList(blastDistrictLocationData);
        allListObj.locationMetricList = locMetRes;
        allListObj.employeeMetricList = this.sortMetricList(blastEmployeesData);

        allListObj.districtList = _.sortBy(Object.keys(self.getGroupedBlastData(blastLocationData, "districtName")));
        allListObj.districtLocationList = _.sortBy(Object.keys(self.getGroupedBlastData(blastDistrictLocationData, "name")));
        allListObj.locationList = _.sortBy(Object.keys(self.getGroupedBlastData(blastLocationData, "name")));
        allListObj.employeeList = _.sortBy(Object.keys(self.getGroupedBlastData(blastStoreEmployeesData, "name")));
        allListObj.allEmployeeList = _.sortBy(Object.keys(self.getGroupedBlastData(blastEmployeesData, "name")));

        return allListObj;
    }

    getDistrictMetricList(filter, callback) {
        let self = this;
        let query = this.indexedDbManager.getBlastLocationDataQuery();
        query.then(function (data) {
            callback(self.sortMetricList(data));
        }, (e) => {

            callback([]);
        });
    }

    getDistrictList(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery().then((blastData) => {
            let groupedBlastData = self.getGroupedBlastData(blastData, "districtName");
            let locationList = Object.keys(groupedBlastData);
            locationList = _.sortBy(locationList);
            callback(locationList);
        }, (error) => {

            callback([]);
        });
    }

    getDistrictLocationMetricList(filter, callback) {
        let self = this;
        let query = this.indexedDbManager.getBlastLocationDataQuery(undefined, filter.districtId);
        query.then(function (data) {
            callback(self.sortMetricList(data));
        }, (e) => {

            callback([]);
        });
    }

    getDistrictLocationList(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(undefined, filter.districtId).then((blastData) => {
            let groupedBlastData = self.getGroupedBlastData(blastData, "name");
            let locationList = Object.keys(groupedBlastData);
            locationList = _.sortBy(locationList);

            callback(locationList);
        }, (error) => {

            callback([]);
        });
    }

    getLocationMetricList(filter, callback) {
        let self = this;
        let query = this.indexedDbManager.getBlastLocationDataQuery();
        query.then(function (data) {
            callback(self.sortMetricList(data));
        }, (e) => {


            callback([]);
        });
    }

    getLocationList(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery().then((blastData) => {
            let groupedBlastData = self.getGroupedBlastData(blastData, "name");
            let locationList = Object.keys(groupedBlastData);
            locationList = _.sortBy(locationList);
            callback(locationList);
        }, (error) => {

            callback([]);
        });
    }

    getEmployeeMetricList(filter, callback) {
        let self = this;
        let query = this.indexedDbManager.getBlastEmployeeDataQuery();
        query.then(function (data) {
            callback(self.sortMetricList(data));
        }, (e) => {

            callback([]);
        });
    }

    getEmployeeList(filter, callback) {
        let self = this;

        this.indexedDbManager.getBlastEmployeeDataQuery(filter.storeId).then((blastData) => {
            let groupedBlastData = self.getGroupedBlastData(blastData, "name");
            let employeeList = Object.keys(groupedBlastData);
            employeeList = _.sortBy(employeeList);
            callback(employeeList);
        }, (error) => {

            callback([])
        });
    }

    getAllEmployeeList(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastEmployeeDataQuery().then((blastData) => {
            let groupedBlastData = self.getGroupedBlastData(blastData, "name");
            let allEmployeeList = Object.keys(groupedBlastData);
            allEmployeeList = _.sortBy(allEmployeeList);
            callback(allEmployeeList);
        }, (error) => {

            callback([])
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////// Get Data

    getDistrictsData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery().then((blastData) => {
            let districtedBlastData = self.groupBlastDataByDistrict(filter, blastData);
            let mappedBlastData = self.mapBlastData(filter, districtedBlastData);
            let sortedBlastData = self.sortBlastData(filter, mappedBlastData, false);
            let groupedBlastData = self.groupDistrictsBlastData(filter, sortedBlastData, "kPIName");
            callback(groupedBlastData);
        }, (error) => {


            callback([])
        });
    }

    getDistrictData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId).then((blastData) => {
            let districtedBlastData = self.groupBlastDataByDistrict(filter, blastData);
            let mappedBlastData = self.mapBlastData(filter, districtedBlastData);
            let sortedBlastData = self.sortBlastData(filter, mappedBlastData, true);
            let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "districtName");

            callback(groupedBlastData);
        }, (error) => {

            callback([])
        });
    }

    getDistrictLocationsData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId, filter.districtId).then((blastData) => {
            let mappedBlastData = self.mapBlastData(filter, blastData);
            let sortedBlastData = self.sortBlastData(filter, mappedBlastData, true);
            let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "kPIName");

            callback(groupedBlastData);
        }, (error) => {


            callback([])
        });
    }

    getDistrictLocationData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId, filter.districtId).then((blastData) => {
            let mappedBlastData = self.mapBlastData(filter, blastData);
            let sortedBlastData = self.sortBlastData(filter, mappedBlastData, true);
            let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "name");

            callback(groupedBlastData);
        }, (error) => {

            callback([])
        });
    }

    //All Location, swipe by metric
    getLocationsData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery().then((blastData) => {

            let tmpLocData = Object.values(blastData.reduce((r, e) => {
                let key = e.storeId + e.reportKpiId;
                if (!r[key]) {
                    r[key] = {}
                    Object.keys(e).forEach(edat => {
                        r[key][edat] = e[edat];
                    });
                } else {
                    r[key].districtId = null;
                    r[key].districtName = "Multi";
                }

                return r;
            }, {}));

            let mappedBlastData = self.mapBlastData(filter, tmpLocData);
            let sortedBlastData = self.sortBlastData(filter, mappedBlastData, false);
            let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "kPIName");
            callback(groupedBlastData);
        }, (error) => {


            callback([])
        });
    }


    //Single Location, All Metrics, swipe by Location
    getLocationData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId).then((blastData) => {

            let tmpLocData = Object.values(blastData.reduce((r, e) => {
                let key = e.storeId + e.reportKpiId;
                if (!r[key]) {
                    r[key] = {}
                    Object.keys(e).forEach(edat => {
                        r[key][edat] = e[edat];
                    });
                } else {
                    r[key].districtId = null;
                    r[key].districtName = "Multi";
                }

                return r;
            }, {}));

            let mappedBlastData = self.mapBlastData(filter, tmpLocData);
            let sortedBlastData = self.sortBlastData(filter, mappedBlastData, true);
            let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "name");

            callback(groupedBlastData);
        }, (error) => {

            callback([])
        });
    }

    //Single location, All Employees, swipe by metric
    getEmployeesData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId).then((locationBlastData) => {
            this.indexedDbManager.getBlastEmployeeDataQuery(filter.storeId).then((blastData) => {

                let mappedBlastData = self.mapBlastData(filter, blastData);
                this.updateLocationNameForEmployee(mappedBlastData, locationBlastData);
                let sortedBlastData = self.sortBlastData(filter, mappedBlastData, false);
                let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "kPIName");

                callback(groupedBlastData);
            }, (error) => {

                callback([])
            });
        }, (error) => {

            callback([])
        });
    }

    //single location, single Employee, all metrics, swipe by employee 
    getEmployeeData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId).then((locationBlastData) => {
            this.indexedDbManager.getBlastEmployeeDataQuery(filter.storeId).then((blastData) => {

                let mappedBlastData = self.mapBlastData(filter, blastData);
                this.updateLocationNameForEmployee(mappedBlastData, locationBlastData);
                let sortedBlastData = self.sortBlastData(filter, mappedBlastData, true);
                let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "name");

                callback(groupedBlastData);
            }, (error) => {

                callback([])
            });
        }, (error) => {

            callback([])
        });
    }

    //All locations, All Employees, single metric, swipe by metric 
    getAllEmployeesData(filter, callback) {

        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId).then((locationBlastData) => {
            this.indexedDbManager.getBlastEmployeeDataQuery(filter.storeId).then((blastData) => {
                this.indexedDbManager.getBlastEmployeeOverwriteDataQuery(filter.storeId).then((overwriteData) => {

                    let tmpData = blastData.reduce((r, e) => {
                        let key = (e.employeeUniqueName != undefined && e.employeeUniqueName != null && e.employeeUniqueName != '' ? e.employeeUniqueName : e.name) + '|' + e.kPIName;
                        if (!r[key]) {
                            r[key] = {
                                avatarUrl: e.avatarUrl,
                                cYMTD: e.cYMTD,
                                cYNOW: e.cYNOW,
                                cYQTD: e.cYQTD,
                                cYWTD: e.cYWTD,
                                cYYTD: e.cYYTD,
                                city: e.city,
                                companyId: e.companyId,
                                defaultSortOrder: e.defaultSortOrder,
                                districtId: e.districtId,
                                districtName: e.districtName,
                                clientAccountId: e.clientAccountId,
                                clientAccountName: e.clientAccountName,
                                employeeId: e.employeeId,
                                isAvg: e.isAvg,
                                isWorking: e.isWorking,
                                kPIName: e.kPIName,
                                reportKpiId: e.reportKpiId,
                                locationId: e.locationId,
                                lYMTD: e.lYMTD,
                                lYNOW: e.lYNOW,
                                lYQTD: e.lYQTD,
                                lYWTD: e.lYWTD,
                                lYYTD: e.lYYTD,
                                lPEOD: e.lPEOD === undefined ? 0 : e.lPEOD,
                                lPEOM: e.lPEOM === undefined ? 0 : e.lPEOM,
                                lPEOQ: e.lPEOQ === undefined ? 0 : e.lPEOQ,
                                lPEOW: e.lPEOW === undefined ? 0 : e.lPEOW,
                                lPEOY: e.lPEOY === undefined ? 0 : e.lPEOY,
                                lPNOW: e.lPNOW === undefined ? 0 : e.lPNOW,
                                lPWTD: e.lPWTD === undefined ? 0 : e.lPWTD,
                                lPMTD: e.lPMTD === undefined ? 0 : e.lPMTD,
                                lPQTD: e.lPQTD === undefined ? 0 : e.lPQTD,
                                lPYTD: e.lPYTD === undefined ? 0 : e.lPYTD,
                                lPODD: e.lPODD === undefined ? 0 : e.lPODD,
                                lPODW: e.lPODW === undefined ? 0 : e.lPODW,
                                lPODM: e.lPODM === undefined ? 0 : e.lPODM,
                                lPODQ: e.lPODQ === undefined ? 0 : e.lPODQ,
                                lPODY: e.lPODY === undefined ? 0 : e.lPODY,
                                lastUpdate: e.lastUpdate,
                                name: e.name,
                                employeeUniqueName: e.employeeUniqueName,
                                phone: e.phone,
                                prec: e.prec,
                                sign: e.sign,
                                storeId: e.storeId,
                                systemName: e.systemName,
                                type: e.type,
                                uId: e.uId,
                                userId: e.userId,
                                userName: e.userName,
                                zzQty: 1
                            }
                        } else {

                            self.compareSets.forEach(set => {
                                r[key][set] += e[set];
                            });

                            r[key].storeId = -10;
                            r[key].phone = r[key].phone === null || r[key].phone === undefined || r[key].phone === '' ? e.phone : r[key].phone;
                            r[key].isWorking = !r[key].isWorking ? e.isWorking : r[key].isWorking;

                            if (r[key].isAvg || r[key].type === 'PCT') {
                                r[key].zzQty += 1;
                            }

                            r[key].userId = r[key].userId === null && e.userId != null ? e.userId : r[key].userId;
                            r[key].userName = r[key].userName === null && e.userName != null ? e.userName : r[key].userName;
                            r[key].systemName = r[key].systemName === null && e.systemName != null ? e.systemName : r[key].systemName;
                        }
                        return r;
                    }, {});
                    let tmpKeys = Object.keys(tmpData);
                    for (var i = 0; i < tmpKeys.length; i++) {

                        self.compareSets.forEach(set => {
                            tmpData[tmpKeys[i]][set] = tmpData[tmpKeys[i]][set] / tmpData[tmpKeys[i]].zzQty;
                        });
                    }

                    tmpData = self.overwriteEmployeeValues(tmpData, overwriteData);

                    let newBlastData = Object.values(tmpData);

                    let mappedBlastData = self.mapBlastData(filter, newBlastData)
                    this.updateLocationNameForEmployee(mappedBlastData, locationBlastData);
                    let sortedBlastData = self.sortBlastData(filter, mappedBlastData, false);
                    let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "kPIName");

                    callback(groupedBlastData);

                }, (error) => {

                    callback([])
                });
            }, (error) => {

                callback([])
            });
        }, (error) => {

            callback([])
        });
    }

    //All locations, single Employee, All metrics, swipe by employee
    getAllEmployeeData(filter, callback) {
        let self = this;
        this.indexedDbManager.getBlastLocationDataQuery(filter.storeId).then((locationBlastData) => {
            this.indexedDbManager.getBlastEmployeeDataQuery(filter.storeId).then((blastData) => {
                this.indexedDbManager.getBlastEmployeeOverwriteDataQuery(filter.storeId).then((overwriteData) => {

                    let tmpData = blastData.reduce((r, e) => {
                        let key = (e.employeeUniqueName != undefined && e.employeeUniqueName != null && e.employeeUniqueName != '' ? e.employeeUniqueName : e.name) + '|' + e.kPIName;
                        if (!r[key]) {
                            r[key] = {
                                avatarUrl: e.avatarUrl,
                                cYMTD: e.cYMTD,
                                cYNOW: e.cYNOW,
                                cYQTD: e.cYQTD,
                                cYWTD: e.cYWTD,
                                cYYTD: e.cYYTD,
                                city: e.city,
                                companyId: e.companyId,
                                defaultSortOrder: e.defaultSortOrder,
                                districtId: e.districtId,
                                districtName: e.districtName,
                                clientAccountId: e.clientAccountId,
                                clientAccountName: e.clientAccountName,
                                employeeId: e.employeeId,
                                isAvg: e.isAvg,
                                isWorking: e.isWorking,
                                kPIName: e.kPIName,
                                reportKpiId: e.reportKpiId,
                                locationId: e.locationId,
                                lYMTD: e.lYMTD,
                                lYNOW: e.lYNOW,
                                lYQTD: e.lYQTD,
                                lYWTD: e.lYWTD,
                                lYYTD: e.lYYTD,
                                lPEOD: e.lPEOD === undefined ? 0 : e.lPEOD,
                                lPEOM: e.lPEOM === undefined ? 0 : e.lPEOM,
                                lPEOQ: e.lPEOQ === undefined ? 0 : e.lPEOQ,
                                lPEOW: e.lPEOW === undefined ? 0 : e.lPEOW,
                                lPEOY: e.lPEOY === undefined ? 0 : e.lPEOY,
                                lPNOW: e.lPNOW === undefined ? 0 : e.lPNOW,
                                lPWTD: e.lPWTD === undefined ? 0 : e.lPWTD,
                                lPMTD: e.lPMTD === undefined ? 0 : e.lPMTD,
                                lPQTD: e.lPQTD === undefined ? 0 : e.lPQTD,
                                lPYTD: e.lPYTD === undefined ? 0 : e.lPYTD,
                                lPODD: e.lPODD === undefined ? 0 : e.lPODD,
                                lPODW: e.lPODW === undefined ? 0 : e.lPODW,
                                lPODM: e.lPODM === undefined ? 0 : e.lPODM,
                                lPODQ: e.lPODQ === undefined ? 0 : e.lPODQ,
                                lPODY: e.lPODY === undefined ? 0 : e.lPODY,
                                lastUpdate: e.lastUpdate,
                                name: e.name,
                                employeeUniqueName: e.employeeUniqueName,
                                phone: e.phone,
                                prec: e.prec,
                                sign: e.sign,
                                storeId: e.storeId,
                                systemName: e.systemName,
                                type: e.type,
                                uId: e.uId,
                                userId: e.userId,
                                userName: e.userName,
                                zzQty: 1
                            }
                        } else {

                            self.compareSets.forEach(set => {
                                r[key][set] += e[set];
                            });

                            r[key].storeId = -10;
                            r[key].phone = r[key].phone === null || r[key].phone === undefined || r[key].phone === '' ? e.phone : r[key].phone;
                            r[key].isWorking = !r[key].isWorking ? e.isWorking : r[key].isWorking;

                            if (r[key].isAvg || r[key].type === 'PCT') {
                                r[key].zzQty += 1;
                            }

                            r[key].userId = r[key].userId === null && e.userId != null ? e.userId : r[key].userId;
                            r[key].userName = r[key].userName === null && e.userName != null ? e.userName : r[key].userName;
                            r[key].systemName = r[key].systemName === null && e.systemName != null ? e.systemName : r[key].systemName;
                        }
                        return r;
                    }, {});
                    let tmpKeys = Object.keys(tmpData);
                    for (var i = 0; i < tmpKeys.length; i++) {

                        self.compareSets.forEach(set => {
                            tmpData[tmpKeys[i]][set] = tmpData[tmpKeys[i]][set] / tmpData[tmpKeys[i]].zzQty;
                        });
                    }

                    tmpData = self.overwriteEmployeeValues(tmpData, overwriteData);

                    let newBlastData = Object.values(tmpData);

                    let mappedBlastData = self.mapBlastData(filter, newBlastData);
                    this.updateLocationNameForEmployee(mappedBlastData, locationBlastData);
                    let sortedBlastData = self.sortBlastData(filter, mappedBlastData, true);
                    let groupedBlastData = self.groupBlastData(filter, sortedBlastData, "name");
                    callback(groupedBlastData);


                }, (error) => {

                    callback([])
                });
            }, (error) => {

                callback([])
            });
        }, (error) => {

            callback([])
        });
    }

    ///////////////////////////////////////////////////////////////////////////////////// Organizing

    mapBlastData(filter, blastData) {

        let self = this;

        return _.map(blastData, (obj) => {

            let cData = {};
            let lData = {};
            let lDataP = {};
            let lDataD = {};
            let ranges = ["NOW", "WTD", "MTD", "QTD", "YTD"];
            for (var i = 0; i < ranges.length; i++) {
                let pName = ranges[i] != "NOW" ? ranges[i] : "CUR";

                cData[pName] = obj["cY" + ranges[i]];

                let tmpLyData = obj["lY" + ranges[i]];
                lData[pName] = tmpLyData;
                if (zzDataCache.settings.compareMode === 'targets') {
                    lData[pName] = self.targetManager.calculateTargetValue(tmpLyData, pName, obj);
                } else if (zzDataCache.settings.compareMode === 'endOfLastPeriod') {
                    let tmpRange = "";
                    switch (ranges[i]) {
                        case "NOW": tmpRange = "lPEOD"; break;
                        case "CUR": tmpRange = "lPEOD"; break;
                        case "WTD": tmpRange = "lPEOW"; break;
                        case "MTD": tmpRange = "lPEOM"; break;
                        case "QTD": tmpRange = "lPEOQ"; break;
                        case "YTD": tmpRange = "lPEOY"; break;
                    }
                    lData[pName] = obj[tmpRange] === undefined || obj[tmpRange] === null ? 0 : obj[tmpRange];
                } else if (zzDataCache.settings.compareMode === 'toDateLastPeriod') {
                    lData[pName] = obj["lP" + ranges[i]];
                } else if (zzDataCache.settings.compareMode === 'thisDayLastPeriod') {
                    let tmpRange = "";
                    switch (ranges[i]) {
                        case "NOW": tmpRange = "lPODD"; break;
                        case "CUR": tmpRange = "lPODD"; break;
                        case "WTD": tmpRange = "lPODW"; break;
                        case "MTD": tmpRange = "lPODM"; break;
                        case "QTD": tmpRange = "lPODQ"; break;
                        case "YTD": tmpRange = "lPODY"; break;
                    }
                    lData[pName] = obj[tmpRange] === undefined || obj[tmpRange] === null ? 0 : obj[tmpRange];
                    cData[pName] = obj["cYNOW"];
                }


                if (lData[pName] > 0) {
                    lDataP[pName] = (cData[pName] / lData[pName]) * 100 - 100;
                } else {
                    lDataP[pName] = 0;
                }
                lDataD[pName] = cData[pName] - lData[pName];
            }

            return {
                avatarUrl: obj.avatarUrl,
                userId: obj.userId,
                phone: obj.phone,
                uId: obj.uId,
                storeId: obj.storeId,
                locationId: obj.locationId,
                name: obj.name,
                employeeUniqueName: obj.employeeUniqueName,
                kPIName: obj.kPIName,
                reportKpiId: obj.reportKpiId,
                districtId: obj.districtId,
                districtName: obj.districtName,
                clientAccountId: obj.clientAccountId,
                clientAccountName: obj.clientAccountName,
                isWorking: (obj.inActive === undefined ? obj.isWorking : obj.inActive),
                sign: obj.sign,
                type: obj.type,
                cData: cData,
                lData: lData,
                lDataP: lDataP,
                lDataD: lDataD,
                lastUpdate: obj.lastUpdate,
                lastBlastDate: obj.lastBlastDate,
                defaultSortOrder: obj.defaultSortOrder,
                isAvg: obj.isAvg,
                zzQty: obj.zzQty
            };
        });
    }

    sortBlastData(filter, blastData, metricsOnly) {
        //CUR,WTD,MTD,QTD,YTD
        var rangePart = "NOW";
        if (filter.range != "CUR") {
            rangePart = filter.range;
        }

        //CYNOW,CYWTD,CYQTD,LYNOW,LYWTD,LYMTD,LYQTD,LYYTD
        let sortColumn = "name";
        if (metricsOnly) {
            sortColumn = 'defaultSortOrder';
        }
        else if (filter.sortBy === "DEFAULT") {
            sortColumn = (metricsOnly == true ? "defaultSortOrder" : "name");
        }
        else if (filter.sortBy === "NAME") {
            sortColumn = "name"
        }
        else if (filter.sortBy === "cY") {
            sortColumn = "cData";
        }
        else if (filter.sortBy === "lY") {
            switch (filter.dataMode) {
                case "P":
                    sortColumn = "lDataP";
                    break;
                case "D":
                    sortColumn = "lDataD";
                    break;
                default:
                    sortColumn = "lData";
                    break;
            }
        }

        let sortedData;
        if (metricsOnly) {
            sortedData = _.sortBy(blastData, (obj) => { return obj[sortColumn] });
        } else if (filter.sortBy === 'cY' || filter.sortBy === 'lY') {
            if (filter.sortByDir == "DESC") {
                sortedData = _.sortBy(blastData, (obj) => { return obj[sortColumn][filter.range] }).reverse();
            }
            else {
                sortedData = _.sortBy(blastData, (obj) => { return obj[sortColumn][filter.range] });
            }
        } else {
            if (filter.sortByDir == "DESC") {
                sortedData = _.sortBy(blastData, (obj) => { return obj[sortColumn] }).reverse();
            }
            else {
                sortedData = _.sortBy(blastData, (obj) => { return obj[sortColumn] });
            }
        }

        return sortedData;
    }

    groupBlastData(filter, blastData, groupByColumn) {

        var groupedData = this.getGroupedBlastData(blastData, groupByColumn);

        let keys = Object.keys(groupedData);

        groupedData.totals = {};
        for (var i = 0; i < keys.length; i++) {
            if (groupedData[keys[i]].length > 0 && (groupedData[keys[i]][0].type === 'PCT' || groupedData[keys[i]][0].isAvg)) {
                groupedData.totals[keys[i]] = this.calculateBlastAverages(groupedData[keys[i]]);
            } else {
                groupedData.totals[keys[i]] = this.calculateBlastTotals(groupedData[keys[i]]);
            }
        }
        return groupedData;
    }

    groupDistrictsBlastData(filter, blastData, groupByColumn) {

        var groupedData = this.getGroupedBlastData(blastData, groupByColumn);

        let keys = Object.keys(groupedData);

        groupedData.totals = {};
        for (var i = 0; i < keys.length; i++) {
            if (groupedData[keys[i]].length > 0 && (groupedData[keys[i]][0].type === 'PCT' || groupedData[keys[i]][0].isAvg)) {
                groupedData.totals[keys[i]] = this.calculateDistrictsBlastAverages(groupedData[keys[i]]);
            } else {
                groupedData.totals[keys[i]] = this.calculateBlastTotals(groupedData[keys[i]]);
            }
        }
        return groupedData;
    }

    calculateBlastTotals(groupData) {//groupedData[keys[i]]

        let totals = {
            lDataTotal: {},
            cDataTotal: {},
            cDataPTotal: {},
            cDataDTotal: {},
            type: groupData[0] != undefined ? groupData[0].type : 'NA'
        };
        let ranges = ["CUR", "WTD", "MTD", "QTD", "YTD"];

        for (var j = 0; j < ranges.length; j++) {
            totals.lDataTotal[ranges[j]] = 0;
            totals.cDataTotal[ranges[j]] = 0;
            totals.cDataPTotal[ranges[j]] = 0;
            totals.cDataDTotal[ranges[j]] = 0;

            _.each(groupData, (obj) => {
                totals.lDataTotal[ranges[j]] += obj.lData[ranges[j]];
                totals.cDataTotal[ranges[j]] += obj.cData[ranges[j]];
            });

            if (totals.lDataTotal[ranges[j]] > 0) {
                totals.cDataPTotal[ranges[j]] = (totals.cDataTotal[ranges[j]] / totals.lDataTotal[ranges[j]]) * 100 - 100;
            }

            totals.cDataDTotal[ranges[j]] = (totals.cDataTotal[ranges[j]] - totals.lDataTotal[ranges[j]]);
        }

        return totals;
    }

    calculateBlastAverages(groupData) {//groupedData[keys[i]]
        let totals = {
            lDataTotal: {},
            cDataTotal: {},
            cDataPTotal: {},
            cDataDTotal: {},
            type: groupData[0] != undefined ? groupData[0].type : 'NA'
        };
        let ranges = ["CUR", "WTD", "MTD", "QTD", "YTD"];

        for (var j = 0; j < ranges.length; j++) {
            totals.lDataTotal[ranges[j]] = 0;
            totals.cDataTotal[ranges[j]] = 0;
            totals.cDataPTotal[ranges[j]] = 0;
            totals.cDataDTotal[ranges[j]] = 0;

            _.each(groupData, (obj) => {
                totals.lDataTotal[ranges[j]] += obj.lData[ranges[j]];
                totals.cDataTotal[ranges[j]] += obj.cData[ranges[j]];
            });

            totals.lDataTotal[ranges[j]] = totals.lDataTotal[ranges[j]] / (groupData.length > 0 ? groupData.length : 1);
            totals.cDataTotal[ranges[j]] = totals.cDataTotal[ranges[j]] / (groupData.length > 0 ? groupData.length : 1);

            if (totals.lDataTotal[ranges[j]] > 0) {
                totals.cDataPTotal[ranges[j]] = (totals.cDataTotal[ranges[j]] / totals.lDataTotal[ranges[j]]) * 100 - 100;
            }

            totals.cDataDTotal[ranges[j]] = (totals.cDataTotal[ranges[j]] - totals.lDataTotal[ranges[j]]);
        }

        return totals;
    }

    calculateDistrictsBlastAverages(groupData) {//groupedData[keys[i]]
        let totals = {
            lDataTotal: {},
            cDataTotal: {},
            cDataPTotal: {},
            cDataDTotal: {},
            type: groupData[0] != undefined ? groupData[0].type : 'NA'
        };
        let ranges = ["CUR", "WTD", "MTD", "QTD", "YTD"];

        for (var j = 0; j < ranges.length; j++) {
            totals.lDataTotal[ranges[j]] = 0;
            totals.cDataTotal[ranges[j]] = 0;
            totals.cDataPTotal[ranges[j]] = 0;
            totals.cDataDTotal[ranges[j]] = 0;

            let fullQty = 0;
            _.each(groupData, (obj) => {
                totals.lDataTotal[ranges[j]] += obj.lData[ranges[j]] * obj.zzQty;
                totals.cDataTotal[ranges[j]] += obj.cData[ranges[j]] * obj.zzQty;
                fullQty += obj.zzQty;
            });

            totals.lDataTotal[ranges[j]] = totals.lDataTotal[ranges[j]] / (fullQty > 0 ? fullQty : 1);
            totals.cDataTotal[ranges[j]] = totals.cDataTotal[ranges[j]] / (fullQty > 0 ? fullQty : 1);

            if (totals.lDataTotal[ranges[j]] > 0) {
                totals.cDataPTotal[ranges[j]] = (totals.cDataTotal[ranges[j]] / totals.lDataTotal[ranges[j]]) * 100 - 100;
            }

            totals.cDataDTotal[ranges[j]] = (totals.cDataTotal[ranges[j]] - totals.lDataTotal[ranges[j]]);
        }

        return totals;
    }

    getGroupedBlastData(blastData, groupByColumn) {

        if (blastData.length <= 0) {
            return [];
        }

        var groupedData = _.groupBy(blastData, (obj) => {
            return obj[groupByColumn];
        });

        return groupedData;
    }

    ///////////////////////////////////////////////////////////////////////////////////// Other

    sortMetricList(data) {

        if (data.length <= 0) {
            return [];
        }

        data = _.sortBy(data, (obj) => {
            return obj.defaultSortOrder
        });

        let kpiNames = _.map(data, (obj) => {
            return obj.kPIName
        });

        let distinctNames = _.uniq(kpiNames, (obj) => {
            return obj;
        });

        return distinctNames;
    }

    updateLocationNameForEmployee(blastData, locationBlastData) {

        if (locationBlastData.length === 0) {
            return;
        }

        let locationMap = locationBlastData.reduce((r, e) => {
            let key = e.storeId;
            if (!r[key]) {
                r[key] = e.name;
            }
            return r;
        });

        for (var i = 0; i < blastData.length; i++) {
            if (blastData[i].storeId === -10) {
                blastData[i].locationName = "Multi-Location";
            } else {

                var locationName = locationMap[blastData[i].storeId];

                if (locationName != undefined)
                    blastData[i].locationName = locationName;
                else
                    blastData[i].locationName = ""
            }
        }
    }

    groupBlastDataByDistrict(filter, blastData) {

        let tmpData = blastData.reduce((r, e) => {
            let key = e.districtName + '|' + e.kPIName;
            if (!r[key]) {
                r[key] = {
                    cYMTD: e.cYMTD,
                    cYNOW: e.cYNOW,
                    cYQTD: e.cYQTD,
                    cYWTD: e.cYWTD,
                    cYYTD: e.cYYTD,
                    city: "",
                    companyId: e.companyId,
                    defaultSortOrder: e.defaultSortOrder,
                    districtId: e.districtId,
                    districtName: e.districtName,
                    clientAccountId: e.clientAccountId,
                    clientAccountName: e.clientAccountName,
                    isAvg: e.isAvg,
                    isWorking: false,
                    kPIName: e.kPIName,
                    reportKpiId: e.reportKpiId,
                    lYMTD: e.lYMTD,
                    lYNOW: e.lYNOW,
                    lYQTD: e.lYQTD,
                    lYWTD: e.lYWTD,
                    lYYTD: e.lYYTD,
                    lPEOD: e.lPEOD === undefined ? 0 : e.lPEOD,
                    lPEOM: e.lPEOM === undefined ? 0 : e.lPEOM,
                    lPEOQ: e.lPEOQ === undefined ? 0 : e.lPEOQ,
                    lPEOW: e.lPEOW === undefined ? 0 : e.lPEOW,
                    lPEOY: e.lPEOY === undefined ? 0 : e.lPEOY,
                    lPNOW: e.lPNOW === undefined ? 0 : e.lPNOW,
                    lPWTD: e.lPWTD === undefined ? 0 : e.lPWTD,
                    lPMTD: e.lPMTD === undefined ? 0 : e.lPMTD,
                    lPQTD: e.lPQTD === undefined ? 0 : e.lPQTD,
                    lPYTD: e.lPYTD === undefined ? 0 : e.lPYTD,
                    lPODD: e.lPODD === undefined ? 0 : e.lPODD,
                    lPODW: e.lPODW === undefined ? 0 : e.lPODW,
                    lPODM: e.lPODM === undefined ? 0 : e.lPODM,
                    lPODQ: e.lPODQ === undefined ? 0 : e.lPODQ,
                    lPODY: e.lPODY === undefined ? 0 : e.lPODY,
                    lastUpdate: e.lastUpdate,
                    name: e.districtName,
                    phone: e.phone,
                    prec: e.prec,
                    sign: e.sign,
                    storeId: null,
                    type: e.type,
                    uId: e.uId,
                    zzQty: 1
                }
            } else {

                this.compareSets.forEach(set => {
                    r[key][set] += e[set];
                });

                if (r[key].isAvg || r[key].type === 'PCT') {
                    r[key].zzQty += 1;
                }
            }
            return r;
        }, {});

        let tmpKeys = Object.keys(tmpData);
        for (var i = 0; i < tmpKeys.length; i++) {

            this.compareSets.forEach(set => {
                tmpData[tmpKeys[i]][set] = tmpData[tmpKeys[i]][set] / tmpData[tmpKeys[i]].zzQty;
            });
        }

        return Object.values(tmpData);
    }

    getEmployeeUserMap() {
        let self = this;

        return zzDataCache.blastEmployee.reduce((r, e) => {
            if (e.userId != undefined && e.userId != null) {
                let key = e.userId;
                if (!r[key]) {
                    r[key] = e.name;
                }
            }

            return r;
        }, {});
    }

    getEmployeePhoneNumbers(filter, callback) {
        let self = this;

        this.indexedDbManager.getBlastEmployeeDataQuery().then((blastData) => {

            let groupedBlastData = Object.values(blastData.reduce((r, e) => {
                let key = e.name;
                if (!r[key]) {
                    r[key] = e;
                    r[key].storeList = [r[key].storeId]
                }
                else {
                    if (!r[key].storeList.includes(e.storeId)) {
                        r[key].storeList.push(e.storeId);
                    }

                    r[key].phone = r[key].phone === null || r[key].phone === '' || r[key].phone === undefined ? e.phone : r[key].phone;
                }
                return r;
            }, {}));

            let phoneNumberList = [];
            for (var i = 0; i < groupedBlastData.length; i++) {
                phoneNumberList.push({
                    name: groupedBlastData[i].name,
                    phone: groupedBlastData[i].phone,
                    stores: groupedBlastData[i].storeList
                });
            }

            callback(phoneNumberList);
        }, (error) => {

            callback([])
        });
    }

    getLocationPhoneNumbers(filter, callback) {
        let self = this;

        this.indexedDbManager.getBlastLocationDataQuery().then((blastData) => {
            let groupedBlastData = self.getGroupedBlastData(blastData, "name");
            let locationList = Object.keys(groupedBlastData);

            let phoneNumberList = [];
            for (var i = 0; i < locationList.length; i++) {
                phoneNumberList.push({
                    name: locationList[i],
                    phone: groupedBlastData[locationList[i]][0].phone
                });
            }

            callback(phoneNumberList);
        }, (error) => {

            callback([]);
        });
    }

    overwriteEmployeeValues(empData, overwriteData) {
        let overwriteMap = overwriteData.reduce((r, e) => {

            if (e.employeeUniqueName != undefined && e.employeeUniqueName != null && e.name != undefined && e.name != null) {
                let key = e.employeeUniqueName + '|' + e.name;
                if (!r[key]) {
                    r[key] = {
                        uId: e.uId,
                        employeeUniqueName: e.employeeUniqueName,
                        name: e.name,
                        cYNOW: e.cYNOW,
                        cYWTD: e.cYWTD,
                        cYMTD: e.cYMTD,
                        cYQTD: e.cYQTD,
                        cYYTD: e.cYYTD,
                        lYNOW: e.lYNOW,
                        lYWTD: e.lYWTD,
                        lYMTD: e.lYMTD,
                        lYQTD: e.lYQTD,
                        lYYTD: e.lYYTD,
                        lPEOD: e.lPEOD === undefined ? 0 : e.lPEOD,
                        lPEOM: e.lPEOM === undefined ? 0 : e.lPEOM,
                        lPEOQ: e.lPEOQ === undefined ? 0 : e.lPEOQ,
                        lPEOW: e.lPEOW === undefined ? 0 : e.lPEOW,
                        lPEOY: e.lPEOY === undefined ? 0 : e.lPEOY,
                        lPNOW: e.lPNOW === undefined ? 0 : e.lPNOW,
                        lPWTD: e.lPWTD === undefined ? 0 : e.lPWTD,
                        lPMTD: e.lPMTD === undefined ? 0 : e.lPMTD,
                        lPQTD: e.lPQTD === undefined ? 0 : e.lPQTD,
                        lPYTD: e.lPYTD === undefined ? 0 : e.lPYTD,
                        lPODD: e.lPODD === undefined ? 0 : e.lPODD,
                        lPODW: e.lPODW === undefined ? 0 : e.lPODW,
                        lPODM: e.lPODM === undefined ? 0 : e.lPODM,
                        lPODQ: e.lPODQ === undefined ? 0 : e.lPODQ,
                        lPODY: e.lPODY === undefined ? 0 : e.lPODY,
                    }
                } else {

                }
            }

            return r;
        }, {});

        let empKeys = Object.keys(empData);
        empKeys.forEach((key) => {

            if (overwriteMap[key] != undefined && overwriteMap[key] != null) {

                this.compareSets.forEach(set => {
                    empData[key][set] = overwriteMap[key][set];
                });
            }
        });

        return empData;
    }

    loadBlastData(allCompanyFilter, callback) {
        try {
            let broadcastSvc = new BroadcastService();
            let self = this;
            broadcastSvc.blast(allCompanyFilter, (allData) => {
                if (allData.length === undefined) {
                    let blastData = allData;
                    zzDataCache.calendarRatios = blastData.calendarRatios;
                    self.indexedDbManager.saveBlastLocationData(blastData.storeId, blastData.locationData, () => {
                        self.indexedDbManager.saveBlastEmployeeData(blastData.storeId, blastData.employeeData, () => {
                            self.indexedDbManager.saveBlastEmployeeOverwriteData(blastData.employeeOverwriteData, () => {
                                self.indexedDbManager.saveTargetData(blastData.targets, () => {
                                    callback(blastData.lastBlastDate);
                                });
                            });
                        });
                    });
                } else if (allData.length > 0) {
                    for (var i = 0; i < allData.length; i++) {
                        let blastData = allData[i];
                        zzDataCache.calendarRatios = blastData.calendarRatios;
                        self.indexedDbManager.saveBlastLocationData(blastData.storeId, blastData.locationData, () => {
                            self.indexedDbManager.saveBlastEmployeeData(blastData.storeId, blastData.employeeData, () => {
                                self.indexedDbManager.saveBlastEmployeeOverwriteData(blastData.employeeOverwriteData, () => {
                                    self.indexedDbManager.saveTargetData(blastData.targets, () => {
                                        callback(blastData.lastBlastDate);
                                    });
                                });
                            });
                        });
                    }
                } else {
                    self.indexedDbManager.clearBlastLocationData(() => {
                        self.indexedDbManager.clearBlastEmployeeData(() => {
                            self.indexedDbManager.clearBlastEmployeeOverwriteData(() => {
                                self.indexedDbManager.clearTargetData(() => {
                                    callback([]);
                                });
                            });
                        });
                    });
                }
            }, (error) => {

                alert(this.errmsg);
                callback();
            });
        } catch (ex) {
            ;
            alert(this.errmsg);
            callback();
        }
    }

    loadGroupsBlastData(allCompanyFilter, callback) {
        try {
            let broadcastSvc = new BroadcastService();
            let self = this;
            broadcastSvc.groupsBlast(allCompanyFilter, (allData) => {
                if (allData.length > 0) {
                    for (var i = 0; i < allData.length; i++) {
                        let blastData = allData[i];
                        zzDataCache.calendarRatios = blastData.calendarRatios;
                        self.indexedDbManager.saveGroupsBlastLocationData(blastData.storeId, blastData.locationData, () => {
                            self.indexedDbManager.saveGroupsBlastEmployeeData(blastData.storeId, blastData.employeeData, () => {
                                self.indexedDbManager.saveGroupsBlastEmployeeOverwriteData(blastData.employeeOverwriteData, () => {
                                    self.indexedDbManager.saveTargetData(blastData.targets, () => {
                                        callback(blastData.lastBlastDate);
                                    });
                                });
                            });
                        });
                    }
                } else {
                    self.indexedDbManager.clearBlastLocationData(() => {
                        self.indexedDbManager.clearBlastEmployeeData(() => {
                            self.indexedDbManager.clearBlastEmployeeOverwriteData(() => {
                                self.indexedDbManager.clearTargetData(() => {
                                    callback([]);
                                });
                            });
                        });
                    });
                }
            }, (error) => {

                alert(this.errmsg);
                callback();
            });
        } catch (ex) {
            ;
            alert(this.errmsg);
            callback();
        }
    }
}

